'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var Message = require('../../message');

var utils = require('../../utils');

module.exports = function (dht) {
  var log = utils.logger(dht.peerInfo.id, 'rpc:find-node');
  /**
   * Process `FindNode` DHT messages.
   *
   * @param {PeerInfo} peer
   * @param {Message} msg
   * @returns {Promise<Message>}
   */

  return /*#__PURE__*/function () {
    var _findNode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(peer, msg) {
      var closer, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              log('start');

              if (!msg.key.equals(dht.peerInfo.id.id)) {
                _context.next = 5;
                break;
              }

              closer = [dht.peerInfo];
              _context.next = 8;
              break;

            case 5:
              _context.next = 7;
              return dht._betterPeersToQuery(msg, peer);

            case 7:
              closer = _context.sent;

            case 8:
              response = new Message(msg.type, Buffer.alloc(0), msg.clusterLevel);

              if (closer.length > 0) {
                response.closerPeers = closer;
              } else {
                log('handle FindNode %s: could not find anything', peer.id.toB58String());
              }

              return _context.abrupt("return", response);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function findNode(_x, _x2) {
      return _findNode.apply(this, arguments);
    }

    return findNode;
  }();
};